import * as Sentry from "@sentry/react";
import { getMetaContent } from "./api/apiUtils";

Sentry.init({
  release: getMetaContent("version") || "unknown",
  environment: getMetaContent("environment") || "development",
  dsn: "https://b8d7f498cef09b1cc19553c7a7b480a2@o4507562756407296.ingest.us.sentry.io/4508111349809152",
  integrations: [],
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/api-dev.typecrm\.net\/api/,
    /^https:\/\/api.typecrm\.net\/api/,
  ],
});
